/* eslint-disable security/detect-object-injection */
import React, { useContext } from 'react';
import AnimatedPageFade from '../../../../components/Animations/AnimatedPageFade';
import { documentsLanguageContent } from '../../documentsLanguageContent';
import ApplicationContext from '../../../../context/ApplicationContext';
function SignatureSection(props) {
    const { selectedLanguage } = useContext(ApplicationContext);

    return (
        <AnimatedPageFade className={`flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden`}>
            <div className={`pb-[8px] px-[8px]`}>
                <p className={`text-start font-semibold text-[#64A003] text-[24px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex items-center pb-[13px] pt-[8px]`}>
                    <div className='flex items-center w-[60%]'>
                        <img src="/images/Doc.svg" alt="doc" />
                        {documentsLanguageContent['documents'][selectedLanguage]}
                    </div>
                </p>
            </div>
        </AnimatedPageFade>
    );
}

export default SignatureSection;